import { Box, Grid, Link, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useCheckout } from "components/StripeCheckout/useCheckout";
import { PRO_TERMS_AND_CONDITIONS_LINK } from "constants/influencer";
import { trackEvent } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import styles from "../styles";

const ProCard = () => {
  const { plans } = useContext(SubscriptionContext);
  const { getPrice } = useSubscription();
  const { getPromoCodeForPlan } = useCheckout();
  if (!plans) return <></>;
  const promoCode = getPromoCodeForPlan(Plans.PRO_YEARLY);

  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for Pro Plan Clicked", {
      source: "Onboarding Paywall",
    });
  };

  return (
    <Box sx={[styles.card, { backgroundColor: "primary.main" }]}>
      <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
        11x more likely to land a deal
      </Box>

      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={6} alignItems={"flex-end"}>
          <Typography sx={styles.planName} variant="h4" alignItems="flex-end">
            Pro
          </Typography>
          <Typography>
            <Link
              href={PRO_TERMS_AND_CONDITIONS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackTermsAndCondition}
              sx={{
                color: "yellow.main",
                fontSize: 10,
                textDecoration: "underline",
                textDecorationColor: "yellow.main",
              }}
            >
              Terms & Conditions
            </Link>
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Grid
            item
            xs={12}
            sx={styles.startAtText}
            justifyContent="flex-start"
            container
          >
            Starts at <br />
          </Grid>
          <Grid item sx={styles.priceText}>
            {promoCode && (
              <Box component="span">${getPrice(Plans.PRO_YEARLY)}</Box>
            )}{" "}
            <Box component="span" sx={promoCode ? styles.strike : {}}>
              ${plans && plans[Plans.PRO_YEARLY]?.price}/mo
            </Box>
          </Grid>
          {promoCode?.dateEnding && (
            <Grid item xs={12} justifyContent="flex-end" container>
              <Typography sx={{ color: "#d95e58", fontSize: 11 }}>
                until {promoCode?.dateEnding}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProCard;
